module.exports = __webpack_public_path__ + "static/media/sitemap.cc4c9d96.xml";